import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import type { SourceType } from "@/types"

interface ConfigurationFieldsProps {
  sourceType: SourceType
  configuration: Record<string, unknown>
  onChange: (config: Record<string, unknown>) => void
}

export function ConfigurationFields({ sourceType, configuration, onChange }: ConfigurationFieldsProps) {
  function updateField(key: string, value: string) {
    onChange({ ...configuration, [key]: value })
  }

  switch (sourceType) {
    case "webhook":
      return (
        <p className="text-muted-foreground text-sm">
          Webhook URL will be generated after saving.
        </p>
      )

    case "rss":
      return (
        <div className="space-y-2">
          <Label htmlFor="feed_url">Feed URL</Label>
          <Input
            id="feed_url"
            type="url"
            placeholder="https://example.com/feed.xml"
            value={(configuration.feed_url as string) || ""}
            onChange={(e) => updateField("feed_url", e.target.value)}
            required
          />
        </div>
      )

    case "podcast_rss":
      return (
        <div className="space-y-2">
          <Label htmlFor="feed_url">Podcast Feed URL</Label>
          <Input
            id="feed_url"
            type="url"
            placeholder="https://example.com/podcast/feed.xml"
            value={(configuration.feed_url as string) || ""}
            onChange={(e) => updateField("feed_url", e.target.value)}
            required
          />
        </div>
      )

    case "mimeo":
      return (
        <div className="space-y-2">
          <Label htmlFor="segment_ids">Segment IDs (optional)</Label>
          <Input
            id="segment_ids"
            type="text"
            placeholder="6, 21"
            value={(configuration.segment_ids as string) || ""}
            onChange={(e) => updateField("segment_ids", e.target.value)}
          />
          <p className="text-muted-foreground text-xs">
            Uses your connected Mimeo. Leave blank to capture every sent broadcast, or list the segment IDs to capture.
          </p>
        </div>
      )

    case "youtube":
      return (
        <div className="space-y-2">
          <Label htmlFor="channel_id">Channel ID or URL</Label>
          <Input
            id="channel_id"
            type="text"
            placeholder="UCxxxxxxxxxx or https://youtube.com/@channel"
            value={(configuration.channel_id as string) || ""}
            onChange={(e) => updateField("channel_id", e.target.value)}
            required
          />
        </div>
      )

    case "discord":
      return (
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="server_id">Server ID</Label>
            <Input
              id="server_id"
              type="text"
              placeholder="Discord Server ID"
              value={(configuration.server_id as string) || ""}
              onChange={(e) => updateField("server_id", e.target.value)}
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="target_user_id">Target User ID</Label>
            <Input
              id="target_user_id"
              type="text"
              placeholder="Discord User ID to watch"
              value={(configuration.target_user_id as string) || ""}
              onChange={(e) => updateField("target_user_id", e.target.value)}
              required
            />
          </div>
        </div>
      )

    default:
      return null
  }
}
